import React from 'react'

import { cn } from '@/shared/lib/utils'

const Loader = ({ className, ...props }: React.ComponentProps<'div'>) => (
	<div className={cn('relative', className)} {...props}>
		<div className='z-10 h-8 w-8 animate-spin rounded-full border-[6px] border-solid border-primary border-t-transparent' />
	</div>
)
Loader.displayName = 'Loader'
export { Loader }
